export type CheckCategory = 'KeyVault' | 'FunctionRbac' | 'DataPlaneRights' | 'VariableGroup' | 'Pipeline'

export type ItemStatus = 'Ok' | 'DiscrepanciesFound' | 'TargetMissing' | 'Failed' | 'Pending'

export type DiscrepancyCategory =
  | 'SecretMissing'
  | 'SecretTemp'
  | 'RbacRoleMissing'
  | 'CosmosRoleMissing'
  | 'SqlRoleMissing'
  | 'VarGroupTargetMissing'
  | 'VariableMissingInGroup'
  | 'PipelineVarMissingInTargetStage'
  | 'PipelineVarScopedToBothStages'

export interface Discrepancy {
  category: DiscrepancyCategory
  key: string
}

export interface ReleaseCheckItem {
  id: string
  category: CheckCategory
  controlName: string
  targetName: string | null
  ignored: boolean
  lastScanDate: string | null
  status: ItemStatus
  error?: string | null
  discrepancies: Discrepancy[]
}

export const CATEGORY_ORDER: CheckCategory[] = [
  'KeyVault',
  'FunctionRbac',
  'DataPlaneRights',
  'VariableGroup',
  'Pipeline',
]
